import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Mail, Phone, Lock } from "lucide-react";
import "./Membership.css";
import { BACKEND_URL } from "../../../config";

const API = BACKEND_URL;

const Login = ({ closeModal }) => {
  const [input, setInput] = useState("");
  const [stage, setStage] = useState("input");
  const [enteredOtp, setEnteredOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [countdown, setCountdown] = useState(0);

  const navigate = useNavigate();

  const sendOtp = async () => {
    setError("");
    setLoading(true);
    try {
      const response = await axios.post(`${API}/api/auth/login/send-otp`, {
        identifier: input
      });
      // Show OTP in alert for development
      if (response.data.otp) {
        alert(`Your OTP is: ${response.data.otp}`);
      }
      setStage("verify");
      setCountdown(60);
    } catch (err) {
      setError(err?.response?.data?.message || "Unable to send OTP");
    } finally {
      setLoading(false);
    }
  };

  const resendOtp = async () => {
    if (countdown > 0) return;
    setLoading(true);
    try {
      await axios.post(`${API}/api/auth/login/send-otp`, {
        identifier: input
      });
      setCountdown(60);
    } catch (err) {
      setError(err?.response?.data?.message || "Unable to resend OTP");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (countdown <= 0) return;
    const t = setInterval(() => setCountdown(c => c - 1), 1000);
    return () => clearInterval(t);
  }, [countdown]);

  const verifyOtp = async () => {
    setError("");
    setLoading(true);
    try {
      const res = await axios.post(`${API}/api/auth/login/verify`, {
        identifier: input,
        otp: enteredOtp
      });
      if (res.data?.token) localStorage.setItem("ihn_token", res.data.token);
      closeModal?.();
      navigate("/dashboard");
    } catch (err) {
      setError(err?.response?.data?.message || "OTP verification failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="membership-overlay">
      <div className="membership-card">
      

        {stage === "input" && (
          <div className="membership-form">
            <label className="field">
              <span className="label">Phone or Email</span>
              <div>
           
                <input
                  value={input}
                  onChange={e => setInput(e.target.value)}
                  placeholder="Enter phone or email" 
                  className="login-input"
                />
              </div>
            </label>

            {error && <div className="error">{error}</div>}

            <button
              className="otp-btn center"
              style={{marginTop:8, minWidth:120}}
              onClick={sendOtp}
              disabled={loading || !input}
            >
              {loading ? <span className="loader" /> : "Send OTP"}
            </button>
          </div>
        )}

        {stage === "verify" && (
          <div className="membership-form">
            <label className="field">
              <span className="label">Enter OTP</span>
              <div className="input-wrap">
                <Lock size={16} />
                <input
                  value={enteredOtp}
                  onChange={e => setEnteredOtp(e.target.value)}
                  placeholder="6-digit OTP"
                />
              </div>
            </label>

            {error && <div className="error">{error}</div>}

            <div className="actions">
              <button className="btn ghost" onClick={() => setStage("input")}>
                Back
              </button>
              <button
                className="btn ghost"
                onClick={resendOtp}
                disabled={countdown > 0}
              >
                {countdown > 0 ? `Resend in ${countdown}s` : "Resend"}
              </button>
              <button className="btn primary" onClick={verifyOtp}>
                {loading ? <span className="loader" /> : "Verify"}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Login;
